import React, { FC } from 'react';
import { GenNavTile, DynamicComponent, GenInternalLink } from '@/components';
import { TypeAccountNavTileFields } from '@/core/generated-types';
import { TypeAccountSettingsPageTranslations } from '@/utils/translations/types/TypeAccountSettingsPageTranslations';
import { TypeUserRecord } from '@/lib/api/accountManager/types';
import {
  TypeExternalPaymentMethod,
  TypeCreditSummary,
} from '@/lib/api/productCatalog/types';

export type PaymentMethodTileProps = {
  t: TypeAccountSettingsPageTranslations;
  user: TypeUserRecord;
  paymentMethod: TypeExternalPaymentMethod | undefined;
  tile: TypeAccountNavTileFields;
  locale: string | undefined;
  creditSummaryData: TypeCreditSummary | undefined;
};

const PaymentMethodTile: FC<PaymentMethodTileProps> = ({
  t,
  user,
  paymentMethod,
  tile,
  creditSummaryData,
}) => {
  const { title, subheader, description, components } = tile;
  const showBalanceCredits =
    creditSummaryData &&
    creditSummaryData.credit_summary &&
    creditSummaryData.credit_summary.credits_available;

  // non subscriber accounts or users with only a partial subscription (i.e. babylist / gift activations)
  // will not have a payment method on file, in which case we won't display this tile.
  // if the user has referral credits, the title will display only the referral balance.
  if (!paymentMethod && !showBalanceCredits) return null;

  return (
    <GenNavTile
      title={title}
      subTitle={subheader}
      description={description}
      titleDecorator={
        paymentMethod ? (
          <GenInternalLink
            href={`/account/settings/payment-method/${user.uuid}`}
            cta={t.editCta}
          />
        ) : null
      }
    >
      {paymentMethod ? (
        <p className="mb-3">{paymentMethod.localized_label}</p>
      ) : null}
      {components &&
        components.map((component) => (
          <DynamicComponent key={component.sys.id} component={component} />
        ))}
    </GenNavTile>
  );
};

export default React.memo(PaymentMethodTile);
